import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Water extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
          Water
        </h2>
        <p>
          It’s important to keep your plants watered, but do so only when needed, as overwatering can be as destructive as no water at all. Water your plant only when the top inch of soil is dry. Poke your finger into the soil and see if it feels dry up to your first knuckle. If so, add water until you see about 20% of runoff water drain out the bottom of your pot. One thing to keep an eye out for. If water takes a long time to come out the bottom, or if pots take longer than 5 days to dry out before the next watering, you may have a problem with drainage.
        </p>
        <p>
          Never spray water over your buds during the flowering stage. This greatly increases the humidity and increases the chance of mold which can destroy your crop. 
        </p>
        <p>
          Don’t let your plants sit in stagnant water for long periods of time as the pH will change and eventually be redrawn back into the plant. Sitting water also attracts bugs and mold.
        </p>
        <div className="guide__shopping-list">
          <h3>Shopping List</h3>

          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B0039EEN0M&asins=B0039EEN0M&linkId=69d1e918549d2d47ef10550611202605&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
          </iframe>

          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B00GFHVTL6&asins=B00GFHVTL6&linkId=1758d1dc6cf5bdbea4d4571946c0ba52&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
          </iframe>

        </div>
        <GuideButton slugTo="ph" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/one_water.js